/**
 * UI permission-keys for the `ENGAGEMENT` route (ENT-284).
 *
 * Typed mirror of the BE CSV (the BE is the source of truth). Gates the
 * `/engagements` route subtree and in-page affordances. Sidebar visibility is
 * decided separately by {@link GlobalAclKeys.sidebarEngagements} (module `sidebar`).
 *
 * Key format: `{module}:{object}`.
 */
export const EngagementAclKeys = {
  /** Read the engagements list (`/engagements`). */
  listingRead: 'engagements:listing_read',
  /** Read a single engagement (`/engagements/$id`). */
  detailRead: 'engagements:detail_read',
  /** Create a new engagement (`/engagements/new`). */
  create: 'engagements:create',
  /** Reveal a PII field value on the engagement detail page (PLATFORM_ADMIN only). */
  piiReveal: 'engagements:pii_reveal',
} as const;

export type EngagementAclKey = (typeof EngagementAclKeys)[keyof typeof EngagementAclKeys];
